import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.25 19.686c-.022.15-.077.288-.151.306a.329.329 0 0 1-.312-.103c-.102-1.205-.453-2.293-1.014-3.35-.839-1.624-2.135-2.919-3.776-3.723a5.804 5.804 0 0 0-1.784-.538c-.091-.013-.21-.12-.213-.2-.003-.114.099-.224.222-.245 2.876-.486 5.193-3.176 6.1-5.87.191-.569.28-1.106.362-1.697.024-.173.197-.281.355-.264.159.017.282.144.305.332.306 2.58 1.941 5.076 4.104 6.468.77.495 1.565.805 2.47.944.101.015.189.195.194.28.006.101-.064.323-.186.341a6.286 6.286 0 0 0-2.455.9c-2.179 1.357-3.856 3.825-4.222 6.42v-.001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }